import { isPopulatedArray } from './array';
/**
 * Nests an array of Nodes assuming they have a parent meta data (parent value)
 *
 * @param id when invoking it, set it to the root Node value
 */
export const nest = (items, id) => items
    .filter((item) => item.meta?.parent === id)
    .map((item) => ({
    ...item,
    children: nest(items, item.value),
}));
export const flattenNodes = (nodes) => {
    let children = [];
    const flattenMembers = nodes.map((m) => {
        if (m.children && m.children.length) {
            children = [...children, ...m.children];
        }
        return m;
    });
    return flattenMembers.concat(children.length ? flattenNodes(children) : children);
};
export const getLeafNodes = (nodes) => {
    const leafs = [];
    const getLeafs = (nodes) => {
        const children = [];
        nodes.forEach((n) => {
            if (!isPopulatedArray(n.children)) {
                leafs.push(n);
            }
            else {
                children.push(...n.children);
            }
        });
        if (children.length > 0) {
            return getLeafs(children);
        }
        return undefined;
    };
    getLeafs(nodes);
    return leafs;
};
//# sourceMappingURL=tree.js.map